var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "91.226mm",
    viewBox: "0 0 485.46475 323.24034",
    width: "137.01mm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1008.4 -107.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "change1_1"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#d38d5f",
    height: 31.92,
    ry: 11.049,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3,
    transform: "rotate(-9.3491)",
    width: 22.098,
    x: -641.14,
    y: 7.2725
  })), /*#__PURE__*/React.createElement("g", {
    id: "change1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#d38d5f",
    height: 31.92,
    ry: 11.049,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3,
    transform: "rotate(-9.3491)",
    width: 22.098,
    x: -699.72,
    y: 5.0934
  })), /*#__PURE__*/React.createElement("g", {
    id: "change2_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-994.61 173.91c-6.6636 0.078-12.305 2.7422-12.305 2.7422s0.6745 18.113 10.332 22.994c7.8967 3.9914 16.708 3.1218 21.82-1.5996 17.378 21.091 37.274 32.106 57.943 40.031v86.518c0 19.735 12.382 36.469 29.832 42.896-1.6868 3.4576-2.6738 7.5078-2.6738 11.865v27.42c0 12.659 8.1865 22.852 18.355 22.852 10.169 0 18.355-10.192 18.355-22.852v-27.42c0-3.2183-0.53593-6.2745-1.4922-9.0469h14.061c-0.95625 2.7724-1.4902 5.8286-1.4902 9.0469v27.42c0 12.659 8.1865 22.852 18.355 22.852 10.169 0 18.355-10.192 18.355-22.852v-27.42c0-3.2183-0.53398-6.2745-1.4902-9.0469h93.709c-0.95628 2.7724-1.4922 5.8286-1.4922 9.0469v27.42c0 12.659 8.1865 22.852 18.355 22.852 10.169 0 18.355-10.192 18.355-22.852v-27.42c0-3.2183-0.53398-6.2745-1.4902-9.0469h14.834c0.66385 3.6388 2.1681 7.3353 4.5684 10.742l15.793 22.416c7.2912 10.349 19.853 13.966 28.166 8.1094s9.1349-18.903 1.8438-29.252l-15.793-22.416c-0.12376-0.17566-0.25997-0.3341-0.38672-0.50586 9.8193-8.3721 16.035-20.834 16.035-34.809v-88.35c0-25.326-20.389-45.715-45.715-45.715h-211.24c-19.863 0-36.683 12.543-43.018 30.172-14.589-2.5292-34.611-13.362-58.131-25.801 0.10742-0.18849 0.21573-0.37891 0.31445-0.57422 3.9517-7.8181-3.7251-13.548-13.383-18.43-3.018-1.5255-6.2582-2.0238-9.2871-1.9883z",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.98651 -.16371 .16371 .98651 52.419 431.68)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-279.91 -484.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "change2_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-388.57 78.076c-18.436 0-34.245 10.809-41.488 26.457a28.571 22.857 0 0 0 -7.082 -0.74218 28.571 22.857 0 0 0 -28.572 22.857 28.571 22.857 0 0 0 28.572 22.857 28.571 22.857 0 0 0 2.8574 -0.14063v65.854c0 25.326 20.387 45.715 45.713 45.715h65.715c25.326 0 45.715-20.389 45.715-45.715v-65.828a28.571 22.857 0 0 0 2.8574 0.11524 28.571 22.857 0 0 0 28.57 -22.857 28.571 22.857 0 0 0 -28.57 -22.857 28.571 22.857 0 0 0 -7.0879 0.73242c-7.2452-15.642-23.053-26.447-41.484-26.447h-65.715z",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-388.57 78.076c-18.436 0-34.245 10.809-41.488 26.457a28.571 22.857 0 0 0 -7.082 -0.74218 28.571 22.857 0 0 0 -28.572 22.857 28.571 22.857 0 0 0 28.572 22.857 28.571 22.857 0 0 0 2.8574 -0.14063v65.854c0 5.6336 1.0138 11.021 2.8613 15.996a70 100 0 0 0 9.9961 1.1465 70 100 0 0 0 70 -100 70 100 0 0 0 -11.227 -54.285h-25.918z",
    fill: "inherit",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-323.89 78.076c18.436 0 34.245 10.809 41.488 26.457a28.571 22.857 0 0 1 7.082 -0.74218 28.571 22.857 0 0 1 28.572 22.857 28.571 22.857 0 0 1 -28.572 22.857 28.571 22.857 0 0 1 -2.8574 -0.14063v65.854c0 5.6336-1.0138 11.021-2.8613 15.996a70 100 0 0 1 -9.9961 1.1465 70 100 0 0 1 -70 -100 70 100 0 0 1 11.227 -54.285h25.918z",
    fill: "inherit",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change4_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-420 200.93c-4.9949 0-9.7929 0.80388-14.285 2.2715v12.014c0 25.326 20.387 45.715 45.713 45.715h65.715c25.326 0 45.715-20.389 45.715-45.715v-14.285h-142.86z",
    fill: "#fca"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change2_2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -395.97,
    cy: 142.09,
    fill: "#fff",
    fillRule: "evenodd",
    r: 27.308,
    stroke: "#000",
    strokeWidth: "1px"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change2_3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -318.6,
    cy: 142.09,
    fill: "#fff",
    fillRule: "evenodd",
    r: 27.308,
    stroke: "#000",
    strokeWidth: "1px"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -393.69,
    cy: 151.19,
    fill: "inherit",
    fillRule: "evenodd",
    r: 15.93,
    stroke: "#000",
    strokeWidth: "1px"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -314.05,
    cy: 151.19,
    fill: "inherit",
    fillRule: "evenodd",
    r: 15.93,
    stroke: "#000",
    strokeWidth: "1px"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "change3_19"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -661.09,
    cy: -252.75,
    fill: "inherit",
    fillRule: "evenodd",
    rx: 10.241,
    ry: 14.792,
    stroke: "#000",
    strokeWidth: "1px"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_20"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -613.3,
    cy: -252.75,
    fill: "inherit",
    fillRule: "evenodd",
    rx: 10.241,
    ry: 14.792,
    stroke: "#000",
    strokeWidth: "1px"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "change3_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-871.1 190.53c-4.9026 0-9.6191 0.7655-14.039 2.1816a82.254 77.957 0 0 0 80.582 62.705 82.254 77.957 0 0 0 81 -64.887h-147.54z",
    fill: "inherit",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1px"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -653.59,
    cy: 636.9,
    fill: "inherit",
    fillRule: "evenodd",
    rx: 49.721,
    ry: 34.989,
    stroke: "#000",
    strokeWidth: "1px",
    transform: "rotate(24.562)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-645.58 363.45a17.801 23.94 0 0 0 -16.26 14.236c0.58795 1.1426 1.2563 2.2689 2.0274 3.3633l15.793 22.416c1.6184 2.297 3.5055 4.2419 5.5391 5.8457a17.801 23.94 0 0 0 10.703 -21.922 17.801 23.94 0 0 0 -17.803 -23.939z",
    fill: "inherit",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1px"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-891.11 360.99a20.257 23.94 0 0 0 -6.1172 1.1484c3.148 2.1891 6.5822 3.9968 10.244 5.3457-1.6868 3.4576-2.6738 7.5078-2.6738 11.865v27.42c0 0.68441 0.0352 1.3586 0.082 2.0274a20.257 23.94 0 0 0 18.723 -23.867 20.257 23.94 0 0 0 -20.258 -23.939z",
    fill: "inherit",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1px"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-805.16 391.71a13.504 12.891 0 0 0 -12.906 12.869 13.504 12.891 0 0 0 10.877 12.643c1.2895-3.1296 2.0293-6.6734 2.0293-10.445v-15.066z",
    fill: "inherit",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1px"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-709.41 388a10.435 10.435 0 0 0 -5.0176 1.2969v17.473c0 0.28088 0.0252 0.55367 0.0332 0.83203a10.435 10.435 0 0 0 4.9844 1.2676 10.435 10.435 0 0 0 10.434 -10.434 10.435 10.435 0 0 0 -10.434 -10.436z",
    fill: "inherit",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1px"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-694.98 288.28a36.83 27.623 0 0 0 -27.328 26.676 36.83 27.623 0 0 0 36.83 27.623 36.83 27.623 0 0 0 35.932 -21.65c-20.819 0.78679-39.534-12.65-45.434-32.648z",
    fill: "inherit",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1px"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change2_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-673.62 139.96c-18.187 3.0182-32.014 16.27-36.597 32.892a22.857 28.571 80.578 0 0 -7.108 0.42725 22.857 28.571 80.578 0 0 -24.445 27.227 22.857 28.571 80.578 0 0 31.929 17.871 22.857 28.571 80.578 0 0 2.7958 -0.60652l10.781 64.965c4.1461 24.984 27.596 41.76 52.58 37.614l64.828-10.758c24.984-4.1461 41.76-27.598 37.614-52.582l-10.777-64.94a22.857 28.571 80.578 0 0 2.8377 -0.35411 22.857 28.571 80.578 0 0 24.443 -27.226 22.857 28.571 80.578 0 0 -31.927 -17.872 22.857 28.571 80.578 0 0 -6.8724 1.8829c-9.7082-14.245-27.071-22.316-45.254-19.299l-64.828 10.758z",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-657.21 137.23-16.41 2.7246c-18.187 3.0182-32.014 16.27-36.598 32.893a22.857 28.571 80.578 0 0 -7.1074 0.42773 22.857 28.571 80.578 0 0 -24.445 27.227 22.857 28.571 80.578 0 0 31.93 17.871 22.857 28.571 80.578 0 0 2.7949 -0.60742l10.781 64.965c0.67956 4.095 1.8856 7.9652 3.5254 11.562a105.58 77.344 83.488 0 0 49.746 -109.68 105.58 77.344 83.488 0 0 -14.217 -47.385z",
    fill: "inherit",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-603.04 128.75c-2.2344 0.0402-4.4962 0.24383-6.7695 0.6211l-17.445 2.8965a112.33 72.433 75.61 0 0 3.7656 62.553 112.33 72.433 75.61 0 0 51.707 80.635 100 70 80.578 0 0 19.645 0.74023 100 70 80.578 0 0 9.6719 -2.7676c1.0082-5.2103 1.1274-10.69 0.20508-16.248l-10.781-64.965a22.857 28.571 80.578 0 0 2.8418 -0.32813 22.857 28.571 80.578 0 0 24.445 -27.229 22.857 28.571 80.578 0 0 -31.93 -17.871 22.857 28.571 80.578 0 0 -6.8652 1.8926c-8.4937-12.469-22.85-20.211-38.49-19.93z",
    fill: "inherit",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change4_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-684.51 266.3c-4.9275 0.81773-9.5292 2.3962-13.721 4.5795l1.9668 11.852c4.1461 24.984 27.596 41.76 52.58 37.614l64.828-10.758c24.984-4.1461 41.76-27.598 37.614-52.582l-2.3386-14.092-140.93 23.387z",
    fill: "#fca"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change2_6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -694.84,
    cy: 91.8,
    fill: "#fff",
    fillRule: "evenodd",
    r: 27.308,
    stroke: "#000",
    strokeWidth: "1px",
    transform: "rotate(-9.4223)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change2_7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -617.47,
    cy: 91.8,
    fill: "#fff",
    fillRule: "evenodd",
    r: 27.308,
    stroke: "#000",
    strokeWidth: "1px",
    transform: "rotate(-9.4223)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_14"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -692.56,
    cy: 100.9,
    fill: "inherit",
    fillRule: "evenodd",
    r: 15.93,
    stroke: "#000",
    strokeWidth: "1px",
    transform: "rotate(-9.4223)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_15"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -612.91,
    cy: 100.9,
    fill: "inherit",
    fillRule: "evenodd",
    r: 15.93,
    stroke: "#000",
    strokeWidth: "1px",
    transform: "rotate(-9.4223)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_16"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -680.05,
    cy: 181.69,
    fill: "inherit",
    fillRule: "evenodd",
    rx: 10.241,
    ry: 14.792,
    stroke: "#000",
    strokeWidth: "1px",
    transform: "rotate(-9.4223)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_17"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -632.26,
    cy: 181.69,
    fill: "inherit",
    fillRule: "evenodd",
    rx: 10.241,
    ry: 14.792,
    stroke: "#000",
    strokeWidth: "1px",
    transform: "rotate(-9.4223)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "change3_18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-901.28 201.86c-5.7407 5.0397-10.205 11.496-12.844 18.84-10.731-1.8603-24.421-8.2304-40.26-16.41a39.899 30.078 17.164 0 0 -5.4512 9.0313c13.494 11.632 28.049 19.015 43.016 24.754v18.285a39.899 30.078 17.164 0 0 33.137 -19.248 39.899 30.078 17.164 0 0 -17.598 -35.252z",
    fill: "inherit",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1px"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCow);
export default __webpack_public_path__ + "static/media/cow.caef99ab8c0fd06c78cc0fac328dda37.svg";
export { ForwardRef as ReactComponent };